<template>
	<div>
		<!-- <mainHead :title="mainHeadTitle" @btnClick="addTableData"></mainHead> -->
		<div class="mianPage">
			<div class="titleRow">{{adEditTitle}}</div>
			<div class="splitLine"></div>
			<el-form inline class="el-form el_dialog_form" label-width="120px" :rules="adRulesApi" :model="mediaADFormData"
				ref="ruleMediaForm">
				<el-form-item label="所属应用：" prop="appId">
					<el-select v-model="appFormData" filterable clearable size="small" :disabled="isAdEditDialog" style="width: 50%;"
					@change="appSelectChange">
						<el-option v-for="item in mediaAppOptions" :key="item.value" :label="item.label" :value="item">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="广告类型：" prop="type">
					<el-select v-model="adTypeFormData" clearable size="small" :disabled="isAdEditDialog" style="width: 50%;"
					@change="adTypeSelectChange">
						<el-option v-for="item in adTypeOptions" :key="item.value" :label="item.label" :value="item">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="渲染类型：" prop="isSelfRender">
					<el-radio v-for="item in isSelfRenderShowOptions" :key="item.value" v-model="mediaADFormData.isSelfRender"
						:label="item.value" :disabled="isAdEditDialog" @change="isSelfRenderChange">{{item.label}}</el-radio>
				</el-form-item>
				<el-form-item label="模板选择：" required v-show="isShowModelType">
					<div class="styleList flex_start">
						<div class="styleCheckBox flex_start" :class="{styleBoxActive:item.checked==true}" v-for="(item,index) in styleCheckList" :key="index">
							<img :src="item.imgs" alt="" v-show="!item.checked" />
							<img :src="item.imgsSelected" alt="" v-show="item.checked" />
							<div class="styleTxt">{{item.name}}</div>
							<el-checkbox class="checkeds" size="medium" @change="checkChange($event,index)" v-model="item.checked">
								<div class="checkContainer"></div>
							</el-checkbox>
						</div>
					</div>
				</el-form-item>
				<el-form-item label="广告位名称：" prop="name">
					<el-input clearable size="small" placeholder="请输入" v-model="mediaADFormData.name" style="width: 50%;"></el-input>
				</el-form-item>
				<el-collapse style="width: 53.5%;" v-if="isAdEditDialog">
					<el-collapse-item title="更多操作" name="1">
					  <el-form-item label="加载广告：" v-if="isAdEditDialog">
					  	<el-select v-model="mediaADFormData.loadTypeId" clearable size="small">
					  		<el-option v-for="item in loadTypeSelectData" :key="item.value" :label="item.label" :value="item.value">
					  		</el-option>
					  	</el-select>
					  </el-form-item>
					  <el-form-item label="计数点：" prop="" v-if="isAdEditDialog">
					  	<el-input clearable size="small" placeholder="请输入" v-model="mediaADFormData.countPoint"></el-input>
					  </el-form-item>
					</el-collapse-item>
				</el-collapse>
				
				<div class="card-bottom flex_center">
					<el-button @click="closeMediaDialog" size="medium">取消</el-button>
					<el-button type="primary" @click="confirmMedia('ruleMediaForm')" size="medium">确定</el-button>
				</div>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				adEditTitle: '广告位新增',
				loadTypeSelectData: [], // 加载类型拉下列表
				adTypeOptions: this.$api.adsTypeOptions, // 广告类型下拉选择
				mediaAppOptions: [], // 媒体APP下拉选择列表
				isSelfRenderOptions: [
					{label: '自渲染', value: '1'},
					{label: '模版渲染', value: '0'},
				], // 渲染类型单选列表，字段值使用isSelfRender
				adRulesApi: {
					appId: [{required: true,message: '请选择所属应用',trigger: 'change'}],
					type: [{required: true,message: '请选择广告类型',trigger: 'change'}],
					name: [{required: true,message: '请输入广告位名称',trigger: 'blur'}],
				},
				// 模板选择列表
				styleCheckList: [
					{imgs:require('../../assets/images/style1.png'),imgsSelected:require('../../assets/images/styleSelected1.png'),
					name:'上文下图',checked:true},
					{imgs:require('../../assets/images/style2.png'),imgsSelected:require('../../assets/images/styleSelected2.png'),
					name:'上图下文',checked:true},
					{imgs:require('../../assets/images/style3.png'),imgsSelected:require('../../assets/images/styleSelected3.png'),
					name:'文字浮层',checked:true},
					{imgs:require('../../assets/images/style4.png'),imgsSelected:require('../../assets/images/styleSelected4.png'),
					name:'左图右文',checked:true},
					{imgs:require('../../assets/images/style5.png'),imgsSelected:require('../../assets/images/styleSelected5.png'),
					name:'左文右图',checked:true},
				],
				mediaADFormData: {
					name: '',
					type: '',
					isSelfRender: '0'
				}, // 媒体广告位表单数据
				isAdEditDialog: false, //广告弹框是否编辑
				styleChecked: false,
				id: '',
				appFormData: {},
				adTypeFormData: {},
			}
		},
		computed: {
			// 非信息流广告仅保留模板渲染选项
			isSelfRenderShowOptions() {
				if(this.mediaADFormData.type=='INFORMATION_AD'){
					return this.isSelfRenderOptions
				}
				return this.isSelfRenderOptions.filter((item) => item.value == '0')
			},
			// 模板选择仅在信息流广告且渲染类型为模板渲染时显示
			isShowModelType() {
				return this.mediaADFormData.type=='INFORMATION_AD'&&this.mediaADFormData.isSelfRender=='0'
			},
		},
		activated(){
			this.appFormData = {}
			this.adTypeFormData = {}
			this.mediaADFormData = {
				name: '',
				type: '',
				isSelfRender: '0'
			}
			this.$refs['ruleMediaForm'].resetFields();
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				this.getloadTypeSelectData(this.$route.query.appId)
				this.getFormData();
				this.isAdEditDialog = true
				this.adEditTitle = '广告位编辑'
			}else{
				this.getMediaAppOption();
				// this.getADTypeOption();
				this.isAdEditDialog = false
				this.adEditTitle = '广告位新增'
				if (this.$route.query.appId) {
					this.mediaADFormData.appId = this.$route.query.appId
				}
				this.setIsSelfRenderByAdType()
			}
		},
		mounted() {
			
		},
		methods: {
			// 获取媒体APP下拉列表
			async getMediaAppOption() {
				let res = await this.$http.get(this.$api.common.mediaAppOptionFilter);
				this.mediaAppOptions = res.data
				if(this.mediaADFormData.appId){
					this.mediaAppOptions.forEach((item) => {
						if(item.value == this.mediaADFormData.appId){
							this.appFormData = item
						}
					})
				}
			},
			// 获取广告类型下拉列表
			async getADTypeOption() {
				let res = await this.$http.get(this.$api.common.adTypeOption);
				this.adTypeOptions = res.data
				if(this.mediaADFormData.type){
					this.adTypeOptions.forEach((item) => {
						if(item.value == this.mediaADFormData.type){
							this.adTypeFormData = item
						}
					})
				}
			},
			// 获取加载类型下拉列表
			async getloadTypeSelectData(appId){
				let data = {appId:appId}
				let res = await this.$http.get(this.$api.common.mediaAdsOption,data);
				this.loadTypeSelectData = res.data
			},
			// 获取详情信息
			async getFormData() {
				let data = {
					pageNum: 1,
					pageSize: 10,
					id: this.id
				}
				let res = await this.$http.post(this.$api.mediaAd.adsList, data);
				if(res.data.list&&res.data.list.length>0){
					this.mediaADFormData = res.data.list[0];
					this.setIsSelfRenderByAdType()
					this.getMediaAppOption();
					// this.getADTypeOption();
					if(this.mediaADFormData.type){
						this.adTypeOptions.forEach((item) => {
							if(item.value == this.mediaADFormData.type){
								this.adTypeFormData = item
							}
						})
					}
					// 广告位模版选中回显
					if(this.mediaADFormData.type=='INFORMATION_AD'){
						if(this.mediaADFormData.modelType){
							this.styleCheckList.forEach((items)=>{
								items.checked = false
							})
							this.mediaADFormData.modelType = this.mediaADFormData.modelType.split(',');
							this.mediaADFormData.modelType.forEach((item,index)=>{
								this.styleCheckList[item-1].checked = true
							})
						}
					}
				}
			},
			appSelectChange(e){
				if(e.value){
					this.mediaADFormData.appId = e.value
				}
				if(this.appFormData.value && this.adTypeFormData.value){
					this.generateAdsName();
				}
			},
			adTypeSelectChange(e){
				if(e&&e.value){
					this.$set(this.mediaADFormData,'type',e.value)
				}else{
					this.$set(this.mediaADFormData,'type','')
				}
				this.setIsSelfRenderByAdType()
				if(this.appFormData.value && this.adTypeFormData.value){
					this.generateAdsName();
				}
			},
			// 根据广告类型初始化渲染类型，非信息流默认模板渲染
			setIsSelfRenderByAdType(){
				if(this.mediaADFormData.type!='INFORMATION_AD'){
					this.$set(this.mediaADFormData,'isSelfRender','0')
					return
				}
				if(this.mediaADFormData.isSelfRender===undefined||this.mediaADFormData.isSelfRender===null||this.mediaADFormData.isSelfRender===''){
					this.$set(this.mediaADFormData,'isSelfRender','0')
				}else{
					this.$set(this.mediaADFormData,'isSelfRender',String(this.mediaADFormData.isSelfRender))
				}
			},
			// 渲染类型切换为自渲染时清空不可见的模板选择值
			isSelfRenderChange(e){
				if(e!='0'){
					this.mediaADFormData.modelType = []
				}
			},
			generateAdsName(){
				if(this.adEditTitle == '广告位新增'){
					let timeDate = this.getFormattedDateTime();
					this.mediaADFormData['name'] = this.appFormData.label + '_' + this.adTypeFormData.label + '_' + timeDate
				}
			},
			// 获取格式化时间
			getFormattedDateTime() {
			  const now = new Date();
			  // 获取年份后两位
			  // const year = now.getFullYear().toString().slice(-2);
			  // 获取月份（0-11，需要+1）
			  const month = String(now.getMonth() + 1).padStart(2, '0');
			  // 获取日期
			  const day = String(now.getDate()).padStart(2, '0');
			  // 获取小时
			  const hours = String(now.getHours()).padStart(2, '0');
			  // 获取分钟
			  const minutes = String(now.getMinutes()).padStart(2, '0');
			  // 获取秒数
			  const seconds = String(now.getSeconds()).padStart(2, '0');
			  // 用下划线拼接
			  return `${month}_${day}_${hours}:${minutes}:${seconds}`;
			},
			// 表格弹窗关闭
			closeMediaDialog() {
				// this.dialogVisible = false
				this.$router.go(-1);
			},
			// 媒体信息编辑确认
			confirmMedia(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						// if(this.appFormData.value){
						// 	this.mediaADFormData.appId = this.appFormData.value
						// }
						// if(this.adTypeFormData.value){
						// 	this.mediaADFormData.type = this.adTypeFormData.value
						// }
						if(this.isShowModelType){
							let isModelType = this.styleCheckList.some((items) => items.checked === true)
							if(!isModelType){
								this.$message.warning('请选择广告位模板');
								return
							}
						}
						let modelType = []
						if(this.isShowModelType){
							this.styleCheckList.forEach((item,index) => {
								if(item.checked){
									modelType.push(index+1)
								}
							})
						}
						// console.log(modelType);
						// return
						let data = this.mediaADFormData;
						data['modelType'] = modelType
						if(data.id){
							let res = await this.$http.post(this.$api.mediaAd.adsEdit, data);
							if(res.code ==1 ){
								this.$message.success('修改成功');
								this.closeMediaDialog();
							}
						}else{
							let res = await this.$http.post(this.$api.mediaAd.adsAdd, data);
							if(res.code ==1 ){
								this.$message.success('新增成功');
								this.closeMediaDialog();
							}
						}
						// this.getTableData();
					}
				});
			},
			checkChange(e, index) {
				let obj = this.styleCheckList[index]
				obj.checked = e
				this.$set(this.styleCheckList, index, obj)
			},
		},
	}
</script>

<style scoped>
	.mianPage {
		margin: 20px;
		background: #FFFFFF;
		border-radius: 4px;
		padding: 24px;
	}
	.titleRow{
		font-weight: 500;
		font-size: 17px;
		color: #333333;
		line-height: 22px;
		padding-left: 8px;
		border-left: 2px solid #4F7AFD;
	}
	.splitLine{
		width: 100%;
		height: 1px;
		background: #EEEEEE;
		margin-top: 12px;
	}
	.el-form {
		margin-top: 24px;
		/* flex-wrap: wrap; */
	}
	
	/deep/ .el-form--inline .el-form-item {
		margin-right: 20px !important;
	}
	.styleList{
		flex-wrap: wrap;
		width: 60%;
	}
	.styleCheckBox{
		border: 1px solid #F9F8F7;
		background: #F9F8F7;
		width: 242px;
		height: 90px;
		box-sizing: border-box;
		border-radius: 8px;
		padding: 0 13px;
		align-items: center;
		position: relative;
		cursor: pointer;
		margin-right: 12px;
		color: #333333;
		margin-top: 12px;
	}
	.styleCheckBox img{
		width: 64px;
		height: 64px;
	}
	.styleTxt{
		margin-left: 12px;
		font-weight: 600;
		font-size: 14px;
	}
	.checkContainer{
		position: absolute;
		right: -5px;
		top: 0px;
		z-index: 14;
		width: 242px;
		height: 92px;
	}
	.checkeds {
		position: absolute;
		right: 5px;
		top: 0px;
		z-index: 14;
	}
	.styleBoxActive{
		border: 1px solid #4F7AFD;
		background: #FFFFFF;
		color: #4F7AFD;
	}
	/* .styleTxtActive{
		color: #4F7AFD;
	} */
	.card-bottom {
		padding-right: 30px;
		margin-top: 30px;
	}
	/deep/.el-collapse-item__header{
		margin-left: 22px;
	}
</style>
